export const API_ENDPOINT = 'admin';


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/endpoints.js